module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3 full-width",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c('div', {
    staticClass: "display-flex"
  }, [_c('div', {
    staticStyle: {
      "flex-grow": "1",
      "font-size": "24px",
      "color": "#888"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.formatMillions(_vm.totalAmount)) + "\n            "), _c('LabelMenu', {
    attrs: {
      "labelClass": "heading",
      "menus": [{
          value: 'active',
          text: 'Active'
        },
        {
          value: 'settlement_confirmed_date',
          text: 'Settlements'
        },
        {
          value: 'approved_date',
          text: 'Approvals'
        },
        {
          value: 'submitted_date',
          text: 'Submissions'
        },
        {
          value: 'lead_taken_date',
          text: 'Leads Taken'
        } ]
    },
    model: {
      value: (_vm.dateFilter),
      callback: function($$v) {
        _vm.dateFilter = $$v
      },
      expression: "dateFilter"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.filteredLoanCount) + " Deals Shown")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mr-3 ml-3"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Search..."
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), (_vm.dateFilter !== 'active') ? _c('DateRange', {
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "elevation-1 white pa-3 mb-4 rounded"
  }, [(_vm.dateFilter == 'active') ? _c('GChart', {
    staticClass: "g-chart",
    attrs: {
      "type": "PieChart",
      "data": _vm.lenderSpread,
      "options": _vm.googleChartOptions
    }
  }) : _vm._e(), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, _vm._l((_vm.filteredLoans), function(loan) {
    return _c('tr', {
      key: loan.meta.key
    }, [_c('td', [_c('a', {
      staticClass: "transparent",
      attrs: {
        "href": _vm.transactionLink(loan.meta.key),
        "target": "_blank"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.clientNames(loan.clients)) + "\n                    ")])]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm._f("date")(loan[_vm.dateFilter])) + "\n                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('img', {
      staticStyle: {
        "margin": "0 15px 3px 5px"
      },
      attrs: {
        "src": '/static/images/lenders/' + loan.lender + '.jpg',
        "alt": "",
        "width": "50"
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(loan.lender))])]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm.fullName(loan.broker)) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(loan.total_new_money)) + "\n                ")])])
  }), 0)], 1), _vm._v(" "), (false) ? _c('NoRecordsPlaceholder', [_vm._v("\n        No Records\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-465554e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Charts/RangeChart.vue
// module id = 2530
// module chunks = 1